import teamHero from "../assets/home_furniture2.jpg";
import teamSupportImage from "../assets/cleaning.jpg";
import teamDetailImage from "../assets/office_furniture.jpg";
import { teamMembers } from "../siteData";

const teamHighlights = [
  "Operationally focused leadership that balances supply, logistics, and service delivery",
  "A support structure covering procurement, administration, accounts, and client coordination",
  "A customer-first working style built around timely response and dependable execution",
];

export default function TeamContent() {
  return (
    <>
      <section
        className="page-hero page-hero-team"
        style={{
          backgroundImage: `url(${teamHero})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      >
        <div className="container">
          <div className="page-hero-content">
            <h1 data-aos="fade-right" data-aos-delay="100">
              The people behind our dependable supply and cleaning services.
            </h1>
            <p data-aos="fade-up" data-aos-delay="200">
              Our team combines leadership, procurement discipline, customer
              care, and operational support to keep every delivery and service
              experience well coordinated.
            </p>
          </div>
        </div>
      </section>

      <section className="section-shell">
        <div className="container">
          <div className="section-heading-row">
            <div>
              <h2 data-aos="fade-right" data-aos-delay="100">
                Meet the team
              </h2>
              <p data-aos="fade-up" data-aos-delay="200">
                These badges are designed as placeholders for your real team
                profile photos while keeping the page polished and ready.
              </p>
            </div>
          </div>

          <div className="row g-4">
            {teamMembers.map((member, index) => (
              <div key={member.name} className="col-sm-6 col-xl-4">
                <div
                  className="team-card h-100"
                  data-aos="fade-up"
                  data-aos-delay={100 + index * 70}
                >
                  <div className="team-card-image-wrap">
                    <img src={member.image} alt={member.name} className="team-card-image" />
                  </div>
                  <div className="team-card-body">
                    <div className="team-badge">{member.position}</div>
                    <h3>{member.name}</h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-shell section-soft">
        <div className="container">
          <div className="row g-4 align-items-stretch">
            <div className="col-lg-6" data-aos="fade-up" data-aos-delay="100">
              <div className="editorial-panel h-100">
                <h2>How our team works</h2>
                <p>
                  We keep our operations practical and coordinated so supply
                  requests, cleaning schedules, and customer communication move
                  with clarity from first contact to delivery.
                </p>
                <div className="bullet-grid">
                  {teamHighlights.map((item) => (
                    <div key={item} className="bullet-grid-item">
                      <span />
                      <p>{item}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="row g-4 h-100">
                <div className="col-12" data-aos="fade-up" data-aos-delay="180">
                  <div className="feature-image-card">
                    <img src={teamSupportImage} alt="MS Universal team support" />
                  </div>
                </div>
                <div className="col-12" data-aos="fade-up" data-aos-delay="260">
                  <div className="feature-image-card">
                    <img src={teamDetailImage} alt="MS Universal operations planning" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
